import React from 'react';
import { Typography } from '@mui/material';

type LookerReportsErrorsProps = {
  errorKey: string;
  filter: string;
};

export const LookerReportsErrors = ({errorKey, filter}: LookerReportsErrorsProps) => {
  return (
    <Typography variant='h4' color="error" sx={{fontFamily: 'PlusJakartaSansRegular', mt: 1, ml:2}}>
      Must select {errorKey} to apply {filter} filter
    </Typography>
  );
};
